import styled from 'styled-components';

const SettingsStyle = styled.div`
  background: #0b0f1b;
  min-height: 100vh;
  padding-bottom: 60px;

  .settingsPageHeader {
    padding: 32px 40px 24px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 20px;
  }

  .headContent {
    flex: 1;
    min-width: 280px;
  }

  .settingsTitle {
    font-family: 'Poppins', sans-serif;
    font-size: 28px;
    font-weight: 600;
    letter-spacing: -0.01em;
    text-align: left;
    color: white;
    margin-bottom: 6px;
    line-height: 1.2;
    text-transform: uppercase;
  }

  .settingsSubtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #b8b8b8;
    line-height: 1.5;
  }

  .settingsContent {
    padding: 0 20px;
  }

  .heading {
    color: #ffffff;
  }

  @media (max-width: 900px) {
    .settingsPageHeader {
      padding: 24px 20px 20px;
    }
  }

  @media (max-width: 768px) {
    .settingsPageHeader {
      padding: 20px;
    }

    .settingsTitle {
      font-size: 22px;
    }

    .settingsSubtitle {
      font-size: 13px;
    }
  }

  @media (max-width: 600px) {
    .settingsContent {
      padding: 0 16px;
      padding-bottom: 10px;
    }
  }
`;

export { SettingsStyle };
